var irreducible = require('./irreducible');

module.exports = irreducible('Any', function () { return true; });



//////////////////
// WEBPACK FOOTER
// /root/social-native/socialnative-web/node_modules/tcomb/lib/Any.js
// module id = 595
// module chunks = 69